import { Result } from "antd";

const SignedOut = () => {
	return (
		<Result title="Signed Out" status="success">
			<div className="desc">
				<p>You can now close this browser window.</p>
			</div>
		</Result>
	);
};

export default SignedOut;
